export default "__VITE_ASSET__Dla3F33U__"